import { Immutable } from "immer";
import React from "react";
import { BannerBlock } from "tsi-common-react/src/components/BannerBlock/index";
import { ColumnsCarouselBlock } from "tsi-common-react/src/components/ColumnsCarouselBlock/index";
import { ProductCalloutBlock } from "tsi-common-react/src/components/ProductCalloutBlock/index";
import { ProductFeaturesCalloutBlock } from "tsi-common-react/src/components/ProductFeaturesCalloutBlock/index";
import { PromotionBlock } from "tsi-common-react/src/components/PromotionBlock/index";
import { ValuePropsBarBlock } from "tsi-common-react/src/components/ValuePropsBarBlock/index";

import type {
    PopularProductsBlock as PopularProductsValue,
    PromotionBlock as PromotionBlockValue,
    ValuePropBarBlock,
} from "@reactivated";

import { DetailBlock } from "./DetailBlock";
import { PopularProductsBlock } from "./PopularProductsBlock";

/**
 * Shared Toolbox block dispatchers used by every pillows assembly template
 * (UtilityPageBody, ProductFilterGridPageBody). Each consumer
 * spreads this map and adds its own page-specific overrides on top.
 */
export const toolboxComponentsMap = {
    banner_block: BannerBlock,
    columns_carousel_block: ColumnsCarouselBlock,
    detail_block: DetailBlock,
    product_callout_block: ProductCalloutBlock,
    product_features_callout: ProductFeaturesCalloutBlock,
    promotion_block: (block: {
        index?: number;
        value: Immutable<PromotionBlockValue>;
    }) => (
        <PromotionBlock
            value={block.value}
            blockIndex={(block.index ?? 0) + 1}
        />
    ),
    value_prop_bar_block: (block: { value: Immutable<ValuePropBarBlock> }) => (
        <ValuePropsBarBlock valuePropsData={block.value} />
    ),
} as const;

/**
 * Pillows-shared dispatcher map for the inner ``PillowsPromoConditionalBlock``
 * ``content`` StreamBlock. Identical between UtilityPage and
 * ProductFilterGridPage: both contain ``popular_products`` and ``banner``
 * (see ``server/cms/components/promo_conditional_block.py``).
 */
export const pillowsPromoConditionalInnerMap = {
    banner: BannerBlock,
    popular_products: (innerBlock: {
        value: Immutable<PopularProductsValue>;
    }) => <PopularProductsBlock value={innerBlock.value} />,
} as const;
